import DOMPurify from "dompurify"
import parse from "html-react-parser"
import { Remarkable } from "remarkable"

import styles from "./messages.module.scss"

const md = new Remarkable({ html: false, breaks: true })

const APPLET_URL_RE = /(?<!\()(?:https?:\/\/)?ifttt\.com\/applets\/[A-Za-z0-9_-]+/g

function linkifyAppletUrls(text: string): string {
  return text.replace(APPLET_URL_RE, raw => {
    const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`
    return `[${raw}](${href})`
  })
}

interface Props {
  text: string
}

const MarkdownText = ({ text }: Props) => {
  const html = DOMPurify.sanitize(md.render(linkifyAppletUrls(text)))
  return <div className={styles["assistant-text"]}>{parse(html)}</div>
}

export default MarkdownText
